import { Dispatch, Action } from 'redux';
import type { AppThunkDispatch } from 'src/store.types';

// Returning dispatch instead of a wrapped dispatch causes an infinite loop with thunk
export const wrappedDispatch = (dispatch: Dispatch<Action>) => ({ dispatch });
export interface WrappedDispatch extends ReturnType<typeof wrappedDispatch> {}

export const wrappedThunkDispatch = (dispatch: AppThunkDispatch) => ({ dispatch });
export interface WrappedThunkDispatch extends ReturnType<typeof wrappedThunkDispatch> {}
